var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "underscore"], function (require, exports, underscore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CompositeReadonlyAppFragmentStore = void 0;
    underscore_1 = __importDefault(underscore_1);
    class CompositeReadonlyAppFragmentStore {
        constructor(stores) {
            this.stores = stores;
        }
        makeStoreIter() {
            let i = 0;
            const stores = this.stores;
            return function () {
                if (i >= stores.length) {
                    return null;
                }
                return stores[i++];
            };
        }
        getAppFragmentStore(appFragment) {
            if (appFragment.storeProperties) {
                if (appFragment.storeProperties.writeable) {
                    const storeId = appFragment.storeProperties.storeId;
                    const storeToSave = this.stores.find(store => store.getStoreId() === storeId);
                    return storeToSave;
                }
                console.warn("Cannot be saved. This appfragment is loaded from readolny store: ", appFragment.storeProperties.storeId);
                return undefined;
            }
            const store = this.findFirstWritableAppfragmentStore();
            const allowSave = confirm(`Do you want to be save on ${store.getStoreId()}?`);
            return allowSave ? store : undefined;
        }
        findFirstWritableAppfragmentStore() {
            return this.stores.find((store) => store.isWriteable && store.isWriteable());
        }
        returnFirstResolved(storeIter, debugInfo, handler) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.returnFirstResolvedInternal(storeIter, debugInfo, handler, () => { return Promise.reject("Failed to resolve AppFragment"); });
            });
        }
        returnFirstResolvedInternal(storeIter, debugInfo, handler, atEndCallback) {
            return __awaiter(this, void 0, void 0, function* () {
                const debug = (...args) => { };
                const storeResult = storeIter.next();
                if (storeResult.done || !storeResult.value) {
                    return atEndCallback();
                }
                const store = storeResult.value;
                const result = handler(store);
                return result.then(appFragment => {
                    if (!appFragment) {
                        return this.returnFirstResolvedInternal(storeIter, debugInfo, handler, atEndCallback);
                    }
                    return appFragment;
                }).catch(error => {
                    if (console && console.log) {
                        console.log("Error from store, applying next", error);
                    }
                    return this.returnFirstResolved(storeIter, debugInfo, handler);
                });
            });
        }
        returnFirstResolvedMultiple(storeIterable, debugInfo, handlerIter) {
            return __awaiter(this, void 0, void 0, function* () {
                const handler = handlerIter.next();
                if (handler.done || !handler.value) {
                    return Promise.reject("Failed to resolve AppFragment");
                }
                const storeIter = storeIterable[Symbol.iterator]();
                return this.returnFirstResolvedInternal(storeIter, debugInfo, handler.value, () => {
                    return this.returnFirstResolvedMultiple(storeIterable, debugInfo, handlerIter);
                });
            });
        }
        get(id) {
            return this.returnFirstResolved(this.stores[Symbol.iterator](), () => ["get", id], store => store.get(id));
        }
        getByTypeAndName(appType, appName, options) {
            return this.returnFirstResolved(this.stores[Symbol.iterator](), () => ["getByTypeAndName", appType, appName], store => store.getByTypeAndName(appType, appName, options));
        }
        findFirstByTypeAndNames(appType, appNames, options) {
            const debugInfo = () => ["findFirstByTypeAndNames", appType, appNames];
            if (typeof appNames == "string") {
                appNames = [appNames];
            }
            const handlers = appNames.map(appName => {
                return (store) => store.getByTypeAndName(appType, appName, options);
            });
            return this.returnFirstResolvedMultiple(this.stores, debugInfo, handlers[Symbol.iterator]());
        }
        getAllAppDescriptions(appType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                // TODO also not just flatten but group by name.type key
                return Promise.allSettled(this.stores.map(store => {
                    if (underscore_1.default.isFunction(store.getAllAppDescriptions)) {
                        return store.getAllAppDescriptions(appType, options);
                    }
                    else {
                        console.log("store", store, "does not implemnet getAllAppDescriptions, skipping");
                        return Promise.resolve([]);
                    }
                })).then(values => {
                    return underscore_1.default.flatten(underscore_1.default.flatten(values).map(function (item) {
                        if (item.status == "fulfilled") {
                            return item.value;
                        }
                        else {
                            return null;
                        }
                    }));
                });
            });
        }
        create(appfragment, options) {
            const storeToSave = this.getAppFragmentStore(appfragment);
            if (storeToSave) {
                return storeToSave.create(appfragment, options);
            }
            return null;
        }
        save(appfragment, options) {
            const storeToSave = this.getAppFragmentStore(appfragment);
            if (storeToSave) {
                return storeToSave.save(appfragment, options);
            }
            return null;
        }
        removeById(id, options) {
            for (let store of this.stores) {
                if ("removeById" in store && typeof store.removeById === "function") {
                    try {
                        return store.removeById(id, options);
                    }
                    catch (error) {
                        console.log("Cannot remove appfragment ", id, error);
                    }
                }
            }
            return null;
        }
    }
    exports.CompositeReadonlyAppFragmentStore = CompositeReadonlyAppFragmentStore;
});
